<soft-page>
  <soft-page-header customClass="p-1!">
    <div class="w-full">
      <soft-filter-and-sort
        [filterConfig]="filterConfig"
        [sortConfig]="sortConfig"
        [explorer]="explorerWarenuebernahme"
      />
    </div>
  </soft-page-header>

  <div [softScrollIntoView]="true" scrollBehavior="instant"></div>

  <div class="pb-3">
    @if (explorerWarenuebernahme.result(); as warenuebernahmen) {
      @if ((loading$ | async) === false) {
        @if (anwender(); as anwender) {
          <div class="flex flex-col w-full gap-3 pb-2 lg:mt-3">
            @for (warenuebernahme of warenuebernahmen; track warenuebernahme) {
              <div
                class="soft-card rounded-m flex flex-row justify-between flex-nowrap items-center p-3 cursor-pointer relative overflow-hidden"
                (click)="warenuebernahmeSperrenBestaetigen(warenuebernahme, anwender)"
              >
                <div
                  class="absolute top-0 bottom-0 left-0 w-2"
                  [ngClass]="{
                    'bg-danger-500':
                      warenuebernahme?.anwenderExzess &&
                      anwender?.id !== warenuebernahme?.anwenderExzess?.id,
                    'bg-warning-500':
                      warenuebernahme?.anwenderExzess &&
                      anwender?.id === warenuebernahme?.anwenderExzess?.id,
                    'bg-success-500': !warenuebernahme?.anwenderExzess,
                  }"
                ></div>
                <div class="flex flex-col justify-center flex-nowrap ml-2 mr-1 z-10">
                  @if (warenuebernahme.belegnummer) {
                    <span class="font-semibold mt-1 mb-1">
                      {{
                        '#WWS_WARENUEBERNAHME.UEBERSICHT.LABEL_LIEFERSCHEINNUMMER'
                          | translate
                      }}
                      {{ warenuebernahme.belegnummer }}
                    </span>
                  }
                  @if (warenuebernahme.lieferant) {
                    <div class="flex flex-row items-center flex-nowrap mb-1">
                      <i class="fa-regular fa-building mr-2 text-sm color-light"></i>
                      <span class="text-sm color-light">
                        {{ warenuebernahme.lieferant.lieferantennummer }} |
                        {{ warenuebernahme.lieferant.kurzbez }}
                      </span>
                    </div>
                  }
                  @if (warenuebernahme.bestellnummer) {
                    <div class="flex flex-row items-center flex-nowrap mb-1">
                      <i class="fa-regular fa-file-invoice mr-2 text-sm color-light"></i>
                      <span class="text-sm color-light">
                        {{
                          '#WWS_WARENUEBERNAHME.UEBERSICHT.LABEL_BESTELLUNG'
                            | translate
                        }}
                        {{ warenuebernahme.bestellnummer }}
                      </span>
                    </div>
                  }
                </div>
                <div class="flex flex-col items-end justify-center gap-1">
                  @if (warenuebernahme?.anwender) {
                    <span class="text-sm color-light">
                      {{
                        '#WWS_WARENUEBERNAHME.UEBERSICHT.LABEL_ANWENDER' | translate
                      }}
                      {{ warenuebernahme?.anwender?.anwender }}
                    </span>
                  }
                  @if (warenuebernahme?.anwenderExzess) {
                    <span class="text-xs color-light">
                      {{
                        '#WWS_WARENUEBERNAHME.UEBERSICHT.LABEL_BEARBEITET_VON'
                          | translate
                      }}
                      {{ warenuebernahme?.anwenderExzess?.anwender }}
                    </span>
                  }
                  <i class="fa-regular fa-chevron-right text-sm color-lighter mt-1"></i>
                </div>
              </div>
            }
          </div>
        }
      } @else {
        <div class="w-full lg:mt-3">
          <div
            class="flex flex-col mt-3 justify-between h-[79px] w-full soft-card !p-4 rounded-sm"
            *softRepeat="10"
          >
            <div class="skeleton rounded h-[1.10rem] w-28"></div>
            <div class="skeleton rounded h-[1.10rem] w-24"></div>
          </div>
        </div>
      }
    }
  </div>
</soft-page>
